import React from "react";
import { Link } from "react-router-dom";

const companyLinks = [
  { label: "About", to: "/about", testid: "footer-about-link" },
  { label: "Privacy", to: "/privacy", testid: "footer-privacy-link" },
  { label: "Terms", to: "/terms", testid: "footer-terms-link" },
  { label: "Contact", to: "/contact", testid: "footer-contact-link" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-14">
      <div className="max-w-7xl mx-auto px-5">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          <div className="max-w-xs">
            <Link to="/" className="font-heading font-extrabold text-xl tracking-tighter">
              adyap<span className="text-primary">.</span>
            </Link>
            <p className="text-zinc-500 text-sm mt-3 leading-relaxed">
              Train for the job.
            </p>
          </div>

          <div>
            <h3 className="text-xs tracking-wider uppercase font-semibold text-zinc-500 mb-4">Company</h3>
            <ul className="space-y-2.5 text-sm">
              {companyLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={l.testid} className="text-zinc-400 hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs tracking-wider uppercase font-semibold text-zinc-500 mb-4">Get in touch</h3>
            <a
              href="mailto:hello@adyap.in"
              data-testid="footer-email-link"
              className="text-zinc-400 hover:text-white transition-colors text-sm"
            >
              hello@adyap.in
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-sm text-zinc-500">
          © 2026 Adyap. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
